import React from "react";
import "../Footer.css";

interface AppDownloadsProps {
  appStoreUrl: string;
  playStoreUrl: string;
}

const AppDownloads: React.FC<AppDownloadsProps> = ({ appStoreUrl, playStoreUrl }) => {
  return (
    <div className="footer-app-downloads">
      <div className="footer-app-links">
        <a
          href={appStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-app-link"
        >
          <img
            src={require("../../../assets/img/apple.svg").default}
            alt="App Store"
            className="footer-app-icon"
          />
        </a>
        <a
          href={playStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-app-link"
        >
          <img
            src={require("../../../assets/img/googlePB.svg").default}
            alt="Google Play"
            className="footer-app-icon"
          />
        </a>
      </div>
    </div>
  );
};

export default AppDownloads;
